import React from 'react';
import './SteamersBlock.css';
import ArrowSubTitle from "../../componets/ArrowSubTitle/ArrowSubTitle";
import BlockTitle from "../../componets/BlockTitle/BlockTitle";
import Streamers from "../../componets/Streamers/Streamers";
import {scrollTo} from "../../utils";
import videoBackground from '../../assets/video/Gradient Lite looped compressed.mp4';
import useAutoplayVideo from "../../hooks/useAutoplayVideo";

export default function SteamersBlock() {
    const videoRef = useAutoplayVideo();

    return <div id="streamers" className="steamers-block">
        <div className="steamers-block-content">
            <video className="steamers-block-back-video"
                   ref={videoRef}
                   data-src={videoBackground}
                   preload="none"
                   autoPlay loop
                   muted playsInline
            />
            <BlockTitle title={"стримеры"} color="gray"/>
            <Streamers/>
            <ArrowSubTitle title={"наши клиенты"} onClick={() => {
                scrollTo("clients", "center")
            }} isBlack={false}/>
        </div>
    </div>
}
